import React, { useContext } from "react";
import RemoveDialog from "../../Components/RemoveDialog";
import useSavePublicMoodboard from "./useSavePublicMoodboard";
import BoardsContext from "../boardsContext";
import AppContext from "../../appContext";

export default function RemoveBoardDialog({
  removeDialog,
  setRemoveDialog,
  board,
  setImportedBoard,
}) {
  const {
    app: { sessionId },
  } = useContext(AppContext);
  const savePublicBoard = useSavePublicMoodboard();
  //const saveLocalBoard = useSaveLocalMoodboard();
  const { moodboardDispatch } = useContext(BoardsContext);
  const handleRemove = () => {
    savePublicBoard.mutate({
      id: board.id,
      name: "",
      moodBoardJSON: "",
      sessionId
    });
    //saveLocalBoard.mutate([]);
    //moodboardDispatch({ type: "SET_MOODBOARDS", payload: [] });
    setImportedBoard({ id: "local", name: "None" });
  };
  return (
    <RemoveDialog
      open={removeDialog.open}
      setOpen={setRemoveDialog}
      removeFunction={handleRemove}
      dialogTitle={"Remove graphs from library?"}
      dialogContentText={"These graphs will be removed from your library"}
      dialogActionCancel={"No, keep graphs"}
      dialogActionConfirm={"Yes, remove graphs"}
    />
  );
}
